import { render, staticRenderFns } from "./GarageAccreditedForm.vue?vue&type=template&id=d7f5667a"
import script from "./GarageAccreditedForm.vue?vue&type=script&lang=js"
export * from "./GarageAccreditedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports